// extracted by mini-css-extract-plugin
export default {"root":"CampaignSendMessage_root__OK5fz","tabs":"CampaignSendMessage_tabs__Ft86F","tab":"CampaignSendMessage_tab__8QbKV"};